/**
 * 任务管理  巡查配置
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>巡查配置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="任务名称">
        <el-input
          size="small"
          v-model="formInline.task_name"
          placeholder="输入任务名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="任务编号">
        <el-input
          size="small"
          v-model="formInline.task_number"
          placeholder="输入任务编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="车辆编号">
        <el-input
          size="small"
          v-model="formInline.car_number"
          placeholder="输入车辆编号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
        <el-button size="small" type="primary" @click="handleAdd"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" prop="id" label="ID" width="80">
      </el-table-column>
      <el-table-column
        align="center"
        prop="task_name"
        label="任务名称"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="task_number"
        label="任务编号"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="patrol_cycle"
        label="巡检周期"
        width="100"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="operationer"
        label="运维人员"
        width="140"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="car_group_list"
        label="执行车辆组"
        width="410"
      >
      </el-table-column>
      <el-table-column align="center" prop="remarks" label="备注" width="450">
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEditForm(scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      title="编辑"
      :visible.sync="handleEdit"
      width="30%"
      @click="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      ><div style="margin-right: 5%">
        <el-form ref="form1" :model="form1" :rules="rules" label-width="100px">
          <el-form-item label="任务名称" prop="task_name">
            <el-input
              v-model="form1.task_name"
              size="small"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="任务编号" prop="task_number">
            <el-input
              v-model="form1.task_number"
              size="small"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="巡查周期" prop="patrol_cycle">
            <el-input
              v-model="form1.patrol_cycle"
              size="small"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="运维人员" prop="operationer_name">
            <el-select
              filterable
              v-model="form1.operationer"
              clearable
              @click="editClick()"
              placeholder="请选择"
            >
              <el-option
                size="small"
                v-for="item in options1"
                :key="item.index"
                :label="item.lable"
                :value="item.value"
              >
              </el-option>
              <el-pagination
                @size-change="handleSizeChangeOpEdit"
                @current-change="handleCurrentChangeOpEdit"
                :current-page="page_op.currentPage"
                :page-size="page_op.pageSize"
                :pager-count="5"
                layout="prev, pager, next"
                :total="page_op.total"
              >
              </el-pagination>
            </el-select>
          </el-form-item>
          <el-form-item label="执行车辆组">
            <el-button icon="el-icon-search" @click="editCar"
              >选择车辆组</el-button
            >
            <br />
            <el-tag
              :key="tag"
              v-for="tag in editcars"
              closable
              :disable-transitions="false"
              @close="handleEditClose(tag)"
            >
              {{ tag }}
            </el-tag>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input
              type="textarea"
              v-model="form1.remarks"
              size="small"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-left:10%">
          <el-button size="mini" type="primary" @click="submitForm('form1')"
            >确 定</el-button
          >
          <el-button size="mini" @click="closeDialog('form1')">取 消</el-button>
          
        </div>
      </div>
    </el-dialog>
    <!-- 添加界面 -->
    <el-dialog
      title="添加"
      :visible.sync="dialogFormVisible"
      width="30%"
      @click="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="margin-right: 5%">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="任务名称" prop="task_name">
            <el-input v-model="form.task_name" size="small"></el-input>
          </el-form-item>
          <el-form-item label="任务编号" prop="task_number">
            <el-input
              v-model="form.task_number"
              size="small"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="巡查周期" prop="patrol_cycle">
            <el-input
              v-model="form.patrol_cycle"
              size="small"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="运维人员" prop="operationer">
            <el-select
              filterable
              v-model="form.operationer"
              clearable
              @click="addClick()"
              placeholder="请选择"
            >
              <el-option
                size="small"
                v-for="item in options"
                :key="item.index"
                :label="item.lable"
                :value="item.value"
              >
              </el-option>
              <el-pagination
                @size-change="handleSizeChangeOp"
                @current-change="handleCurrentChangeOp"
                :current-page="pageop.currentPage"
                :page-size="pageop.pageSize"
                :pager-count="5"
                layout="prev, pager, next"
                :total="pageop.total"
              >
              </el-pagination>
            </el-select>
          </el-form-item>
          <el-form-item label="执行车辆组">
            <el-button icon="el-icon-search" @click="addCar()"
              >选择车辆组</el-button
            >
            <br />
            <el-tag
              :key="tag"
              v-for="tag in carlist"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{ tag }}
            </el-tag>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              size="small"
              v-model="form.remarks"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-left:10%">
          
          <el-button size="mini" type="primary" @click="submitAdd('form')">确 定</el-button>
          <el-button size="mini" @click="closeDialog('form')">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 编辑执行车辆组添加 -->
    <el-dialog
      title="执行车辆组"
      :visible.sync="dialogTableVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="carselect">
        <el-form-item label="车辆编号" label-width="80px">
          <el-input v-model="carselect.car_id" size="small" autocomplete="off">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchEdit"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <el-table
        size="small"
        :data="editcarlist"
        ref="multipleTableEdit"
        row-key="id"
        highlight-current-row
        @selection-change="handleSelectionChangeEdit"
        border
        style="width: 100%"
      >
        <el-table-column
          width="50"
          type="selection"
          reserve-selection
        ></el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          width="80"
          prop="id"
          label="编号"
        ></el-table-column>
        <el-table-column
          prop="car_id"
          label="车辆编号"
          width="200"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="120"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_number"
          label="车牌号"
          width="100"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_type"
          label="车辆型号"
          width="140"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_brand"
          label="车辆品牌"
          width="140"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_voltage"
          label="额定电压"
          width="100"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_motor_power"
          label="电机功率"
          width="120"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_max_speed"
          label="最高车速"
          width="180"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_load_mass"
          label="额定载质量"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_curb_weight"
          label="整备质量"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="manufacturing_date"
          label="制造日期"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_color"
          label="车身颜色"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="status"
          label="车辆状态"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#e5e5e5"
              @change="changeSwitch(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="dataSources"
          label="数据来源"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="car_comment"
          label="备注"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          label="车辆司机"
          width="150"
          prop="driver_name"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChangeEdit"
        @current-change="handleCurrentChangeEdit"
        :current-page="page_two.currentPage"
        :page-sizes="[5,10, 15, 25, 50, 100]"
        :page-size="page_two.pageSize"
        background
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page_two.total"
      >
      </el-pagination>
      <div style="margin-top:2%">
        <el-button size="mini" type="primary" @click="submitEditForm">确 定</el-button>
        <el-button size="mini" @click="dialogTableVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 添加的车辆组的添加 -->
    <el-dialog
      title="执行车辆组"
      :visible.sync="adddialogTableVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="addcarselect">
        <el-form-item label="车辆编号" label-width="80px">
          <el-input
            v-model="addcarselect.car_id"
            size="small"
            autocomplete="off"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchCar"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <!-- 车辆组选择 -->
      <el-table
        size="small"
        :data="carlistData"
        row-key="id"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        highlight-current-row
        border
        style="width: 100%"
      >
        <el-table-column
          width="50"
          type="selection"
          reserve-selection
        ></el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          sortable
          prop="id"
          label="编号"
        ></el-table-column>
        <el-table-column
          sortable
          prop="car_id"
          label="车辆编号"
          width="200"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="name"
          label="名称"
          width="120"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_number"
          label="车牌号"
          width="100"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_type"
          label="车辆型号"
          width="140"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_brand"
          label="车辆品牌"
          width="140"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_voltage"
          label="额定电压"
          width="100"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_motor_power"
          label="电机功率"
          width="120"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_max_speed"
          label="最高车速"
          width="180"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_load_mass"
          label="额定载质量"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_curb_weight"
          label="整备质量"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="manufacturing_date"
          label="制造日期"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_color"
          label="车身颜色"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="status"
          label="车辆状态"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#e5e5e5"
              @change="changeSwitch(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="dataSources"
          label="数据来源"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="car_comment"
          label="备注"
          width="150"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          label="车辆司机"
          width="150"
          prop="driver_name"
          align="center"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagetwo.currentPage"
        :page-sizes="[5,10, 15, 25, 50, 100]"
        :page-size="pagetwo.pageSize"
        background
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagetwo.total"
      >
      </el-pagination>
      <div style="margin-top:2%">
        <el-button size="mini" type="primary" @click="submitAddForm">确 定</el-button>
         <el-button size="mini" @click="adddialogTableVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  get_patrol_list,
  get_patrol_car_list,
  get_patrol_op_list,
  get_patrol_add,
  get_patrol_one,
  get_patrol_one_k_v,
  get_car_id_update,
  get_patrol_edit,
  get_patrol_del,
} from "../../api/tast/patrol";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      adddialogTableVisible: false,
      dialogTableVisible: false,
      inputVisible: false,
      inputValue: "",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      // editFormVisible: false, //控制编辑页面显示与隐藏
      dialogFormVisible: false, //取消确定按钮
      handleEdit: false,
      listData: [],
      //车辆组添加
      carlistData: [],
      //编辑车辆组添加
      editcarlist: [],
      //添加
      form: {
        task_name: "",
        task_number: "",
        patrol_cycle: "",
        operationer: "",
        operationer_name:"",
        car_group: "",
        car_group_list: [],
        remarks: "",
      },
      cargroup: [],
      list: [],
      lists: [],
      carsz: [],
      cargroups: [],
      //编辑
      form1: {
        id: "",
        task_name: "",
        task_number: "",
        patrol_cycle: "",
        operationer: "",
        operationer_name:"",
        car_group: "",
        car_group_list: "",
        remarks: "",
      },
      //运维人员添加
      options: [],
      //运维人员编辑
      options1: [],
      // value1: "",
      carlist: [],
      // value1: [],
      editcars: [],
      //添加车辆组的搜索车辆
      carselect: {
        car_id: "",
        car_not_id: "",
        page: 1,
        limit: 5,
      },
      addcarselect: {
        car_id: "",
        car_not_id: "",
        page: 1,
        limit: 10,
      },

      // rules表单验证
      rules: {
        task_name: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
          {
            pattern: /^[0-9\u0391-\uFFE5]+$/,
            message: "请输入正确的任务名称，如：测试01",
            trigger: "blur",
          },
        ],
        task_number: [
          { required: true, message: "请输入任务编号", trigger: "blur" },
          {
            pattern: /^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,20}$/,
            message: "请输入正确的任务编号，如：WHMZ001",
            trigger: "blur",
          },
        ],
        patrol_cycle: [
          { required: true, message: "请输入巡查周期", trigger: "blur" },
          {
            pattern: /^\d+$|^\d+[.]?\d+$/,
            message: "请输入正确的巡查周期，如：2",
            trigger: "blur",
          },
        ],
        operationer: [
          { required: true, message: "请选择运维人员", trigger: "blur" },
        ],
        car_group_list: [
          { required: true, message: "请选择执行车辆组", trigger: "blur" },
        ],
      },
      formInline: {
        task_name: "",
        task_number: "",
        car_number: "",
        patrol_cycle: "",
        operationer: "",
        car_group_list: "",
        remarks: "",
        page: 1,
        limit: 10,
      },
      opInline: {
        page: 1,
        limit: 5,
      },
      op_Inline: {
        page: 1,
        limit: 5,
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      pagetwo: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      page_two: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      pageop: {
        currentPage: 1,
        pageSize: 5,
        total: 10,
      },
      page_op: {
        currentPage: 1,
        pageSize: 5,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取巡检列表
    getdata() {
      window.localStorage.removeItem("patrol_id");
      get_patrol_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res["count"];
        } else {
          this.$message.error(res["message"]);
        }
      });
      // 分页赋值
      // this.pageparm.currentPage = this.formInline.page;
      // this.pageparm.pageSize = this.formInline.limit;
      // this.pageparm.total = res.count;
    },
    //获取车辆列表
    getCarData() {
      get_patrol_car_list(this.addcarselect).then((res) => {
        if (res["code"] === 0) {
          this.carlistData = res.data;
          for (var i = 0; i < this.carlistData.length; i++) {
            this.carlistData[i].status =
              this.carlistData[i].status === 1 ? true : false;
          }
          this.pagetwo.currentPage = this.addcarselect.page;
          this.pagetwo.pageSize = this.addcarselect.limit;
          this.pagetwo.total = res["count"];
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //编辑车辆组
    getCarDataEdit() {
      get_car_id_update(this.carselect).then((res) => {
        if (res["code"] === 0) {
          this.editcarlist = res.data;
          for (var i = 0; i < this.editcarlist.length; i++) {
            this.editcarlist[i].status =
              this.editcarlist[i].status === 1 ? true : false;
          }
          this.page_two.currentPage = this.carselect.page;
          this.page_two.pageSize = this.carselect.limit;
          this.page_two.total = res["count"];
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //添加运维人员
    addClick() {
      get_patrol_op_list(this.opInline).then((res) => {
        if (res["code"] === 0) {
          this.options = res.data;
          this.pageop.currentPage = this.opInline.page;
          this.pageop.pageSize = this.opInline.limit;
          this.pageop.total = res["count"];
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //编辑运维人员
    editClick() {
      get_patrol_op_list(this.op_Inline).then((res) => {
        if (res["code"] === 0) {
          this.options1 = res.data;
          for (let i = 0; i < this.options1.length; i++) {
            if (this.form1.operationer == this.options1[i].value) {
              this.form1.operationer_name = this.options1[i].lable;
            }
            
          }
          this.page_op.currentPage = this.op_Inline.page;
          this.page_op.pageSize = this.op_Inline.limit;
          this.page_op.total = res["count"];
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata();
    },
    carFather() {
      this.addcarselect.page = this.pagetwo.currentPage;
      this.addcarselect.limit = this.pagetwo.pageSize;
      this.getCarData();
    },
    carFatherEdit() {
      this.carselect.page = this.page_two.currentPage;
      this.carselect.limit = this.page_two.pageSize;
      this.getCarDataEdit();
    },
    opFather() {
      this.opInline.page = this.pageop.currentPage;
      this.opInline.limit = this.pageop.pageSize;
      this.addClick();
    },
    op_edtiFather() {
      this.op_Inline.page = this.page_op.currentPage;
      this.op_Inline.limit = this.page_op.pageSize;
      this.editClick();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata();
    },
    searchCar() {
      this.addcarselect.page = 1;
      this.getCarData();
    },
    searchEdit() {
      this.carselect.page = 1;
      this.getCarDataEdit();
    },
    handleSelectionChange(val) {
      this.cargroup = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.cargroup.includes(val[i])) {
          this.cargroup.push(val[i]);
        }
      }
    },
    toggleRowSelect() {
      var that = this;
      that.$nextTick(() => {
        if (that.$refs.multipleTable) {
          that.$refs.multipleTable.clearSelection();
        }
      });
    },
    toggleRowSelectEdit() {
      var that = this;
      that.$nextTick(() => {
        if (that.$refs.multipleTableEdit) {
          that.$refs.multipleTableEdit.clearSelection();
        }
      });
    },
    //显示车辆列表
    addCar() {
      this.adddialogTableVisible = true;
      this.addcarselect.car_id = "";
      this.getCarData();
      this.toggleRowSelect();
    },
    submitAddForm() {
      this.cargroups = [];
      this.carlist = [];
      for (var i = 0; i < this.cargroup.length; i++) {
        this.list.push({
          name: this.cargroup[i].car_id + "-" + this.cargroup[i].car_number,
          id: this.cargroup[i].id,
        });
      }
      for (i in this.list) {
        this.cargroups.push(this.list[i].id);
        this.carlist.push(this.list[i].name);
      }
      var strs = this.cargroups.join(",");
      this.form.car_group = strs;
      this.addcarselect.car_not_id = strs;
      this.addcarselect.page = 1;
      this.adddialogTableVisible = false;
    },
    //添加界面
    handleAdd() {
      this.dialogFormVisible = true;
      this.list = [];
      this.cargroups = [];
      this.addClick();
      this.form = {};
      this.carlist = [];
      this.addcarselect.car_not_id = "";
    },
    //添加页面保存方法
    submitAdd(addData) {
      this.$refs[addData].validate((valid) => {
        if (valid) {
          get_patrol_add(this.form).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              this.dialogFormVisible = false;
              this.getdata();
            } else {
              this.$message.error(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑界面
    handleEditForm(row) {
      window.localStorage.setItem("patrol_id", row.id);
      this.list = [];
      this.cargroups = [];
      this.editcars = [];
      get_patrol_one_k_v(row.id).then((res) => {
        if (res["code"] === 0) {
          this.form1 = res.data;
          get_patrol_one(row.id).then((res) => {
            if (res["code"] === 0) {
              for (let i = 0; i < res.data.length; i++) {
                this.list.push({
                  name: res.data[i].value,
                  id: res.data[i].key,
                });
              }
              for (var i = 0; i < this.list.length; i++) {
                this.cargroups.push(this.list[i].id);
                this.editcars.push(this.list[i].name);
              }
            }
            this.handleEdit = true;
          });
          this.editClick();
        }
      });
    },
    handleSelectionChangeEdit(val) {
      this.cargroup = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.cargroup.includes(val[i])) {
          this.cargroup.push(val[i]);
        }
      }
    },
    editCar() {
      this.dialogTableVisible = true;
      var _str = this.cargroups.join(",");
      this.carselect.car_not_id = _str;
      this.carselect.car_id = "";
      this.getCarDataEdit();
      this.toggleRowSelectEdit();
    },
    submitEditForm() {
      this.dialogTableVisible = false;
      this.cargroups = [];
      this.editcars = [];
      for (let i = 0; i < this.cargroup.length; i++) {
        this.list.push({
          name: this.cargroup[i].car_id + "-" + this.cargroup[i].car_number,
          id: this.cargroup[i].id,
        });
      }
      for (let i in this.list) {
        this.cargroups.push(this.list[i].id);
        this.editcars.push(this.list[i].name);
      }
      var strs = this.cargroups.join(",");
      this.form1.car_group = strs;
      this.carselect.car_not_id = strs;
      this.carselect.page = 1;
    },
    // 编辑页面保存方法
    submitForm(editData) {
      this.list = [];
      // window.localStorage.removeItem("patrol_id")
      this.$refs[editData].validate((valid) => {
        if (valid) {
          get_patrol_edit(this.form1).then((res) => {
            this.handleEdit = false;
            if (res["code"] === 0) {
              this.getdata();
              this.form1 = {};
              this.$message.success(res["message"]);
            } else {
              this.$message.error(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteUser(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal:false,
        type: "warning",
      })
        .then(() => {
          get_patrol_del(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getdata();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getdata();
                }
              } else {
                this.getdata();
              }
            } else {
              this.$message.error(res["message"]);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pagetwo.pageSize = val;
      this.carFather();
    },
    handleCurrentChange(val) {
      this.pagetwo.currentPage = val;
      this.carFather();
    },
    handleSizeChangeEdit(val) {
      this.page_two.pageSize = val;
      this.carFatherEdit();
    },
    handleCurrentChangeEdit(val) {
      this.page_two.currentPage = val;
      this.carFatherEdit();
    },
    handleSizeChangeOp(val) {
      this.pageop.pageSize = val;
      this.opFather();
    },
    handleCurrentChangeOp(val) {
      this.pageop.currentPage = val;
      this.opFather();
    },
    handleSizeChangeOpEdit(val) {
      this.page_op.pageSize = val;
      this.op_edtiFather();
    },
    handleCurrentChangeOpEdit(val) {
      this.page_op.currentPage = val;
      this.op_edtiFather();
    },
    //添加
    handleClose(tag) {
      for (var i in this.list) {
        if (this.list[i].name == tag) {
          this.list.splice(i, 1);
          this.carlist.splice(this.carlist.indexOf(tag), 1);
        }
      }
      this.cargroups = [];
      for (i in this.list) {
        this.cargroups.push(this.list[i].id);
      }
      var str = this.cargroups.join(",");
      this.form.car_group = str;
      this.addcarselect.car_not_id = str;
    },
    //修改
    handleEditClose(tag) {
      for (var i in this.list) {
        if (this.list[i].name == tag) {
          this.list.splice(i, 1);
          this.editcars.splice(this.editcars.indexOf(tag), 1);
        }
      }
      this.cargroups = [];
      for (i in this.list) {
        this.cargroups.push(this.list[i].id);
      }
      var str = this.cargroups.join(",");
      this.form1.car_group = str;
      this.carselect.car_not_id = str;
    },

    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.handleEdit = false;
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 30px;
  width: 100%;
  height: 80px;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/tast_mn/Patrol_mn.vue